import ModalImport from 'Features/Modal/ModalImport';
import {ProModalProps} from 'Components/ProModal';
import {importDict} from '../../service';

export function ImportDictModal({onOk, ...props}: ProModalProps) {
    async function onUpload(file: File) {
        await importDict(file);
        onOk?.();
    }

    return (
        <ModalImport
            {...props}
            title="维度数据导入"
            onUpload={onUpload}
            templateUrl={require('./【导入模板】维度数据导入模板 V0.1.xlsx')}
            templateName="维度数据导入模板"
            restSteps={['2. 在导入模板补充好维度数据后上传文件']}
        />
    );
}
